/** R-03 (D-94): "�����" of a task shows only when the server said the viewer manages it. */
export function mayShowTaskDelete(row: { can_manage_task?: boolean } | null | undefined): boolean {
  return row?.can_manage_task === true;
}
